import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { useCommunity } from "@/context/CommunityContext";
import TopBar from "@/components/TopBar";
import IdeaBlock from "@/components/IdeaBlock";

const TYPE_LABEL = {
  SET_MATCH: "Satz-Match",
  SCORE_MATCH: "Ergebnis-Match",
  LETTER_GAME: "Buchstaben-Spiel",
};

export default function Play() {
  const { community, slug } = useCommunity();
  const [games, setGames] = useState([]);

  useEffect(() => {
    if (!slug) return;
    api.get(`/communities/${slug}/games`).then(({ data }) => setGames(data || [])).catch(() => setGames([]));
  }, [slug]);

  return (
    <div data-testid="play-page">
      <TopBar back="/" title="Spielen" />
      <div className="mx-auto max-w-2xl px-5 py-8">
        <h1 className="text-4xl">Spielen</h1>
        <p className="mt-2 text-sm text-[var(--ink-soft)]">
          Matches und Spiele mit anderen. Jedes Ergebnis wird von der Gegenseite bestätigt.
        </p>

        <div className="mt-8 space-y-4">
          {games.length === 0 ? (
            <p className="rounded-2xl border bg-white p-6 text-sm text-[var(--ink-soft)]" data-testid="play-empty">
              Es sind noch keine Spiele freigegeben.
            </p>
          ) : null}
          {games.map((game, index) => (
            <Link
              key={game.id}
              to={`/spielen/${game.id}`}
              className="card-lift flex overflow-hidden rounded-3xl border bg-white rise"
              style={{ animationDelay: `${index * 60}ms` }}
              data-testid={`game-card-${game.id}`}
            >
              <div className="h-28 w-28 shrink-0 bg-[var(--brand-soft)]">
                {game.image ? <img src={fileUrl(game.image)} alt="" className="h-full w-full object-cover" /> : null}
              </div>
              <div className="min-w-0 flex-1 p-4">
                <p className="eyebrow">{TYPE_LABEL[game.game_type] || "Spiel"}</p>
                <p className="mt-0.5 text-2xl leading-tight">{game.title}</p>
                {game.short_description ? (
                  <p className="mt-1 line-clamp-2 text-sm text-[var(--ink-soft)]">{game.short_description}</p>
                ) : null}
              </div>
            </Link>
          ))}
        </div>

        {community ? <IdeaBlock communityId={community.id} allowed={["GAME"]} /> : null}
      </div>
    </div>
  );
}
